module.exports = __webpack_public_path__ + "img/evo-box.9b1f903c.png";